export const PerfilResource = ($resource, URLAPICLIENTE, URLAPILOGIN, URL_PAYPAL) => {
  "ngInject";

  return $resource(URLAPICLIENTE, {}, {
    getUserData: {
      method: 'GET',
      url: URLAPICLIENTE + '/me',
    },
    saveUserData: {
      method: 'PUT',
      url: URLAPICLIENTE + '/me',
    },
    getBetaFeatures: {
      method: 'GET',
      url: URLAPILOGIN + '/funcionalidades/available',
    },
    getToken: {
      method: 'GET',
      url: URLAPICLIENTE + '/api',
    },
    saveHooks: {
      method: 'POST',
      url: URLAPICLIENTE + '/api',
    },
    getClienteData: {
      method: 'GET',
      url: URLAPICLIENTE + '/clientes/:userId',
      params: {
        userId:'@userId',
      }
    },
    connectPayPal: {
      method: 'POST',
      url: URL_PAYPAL + '/paypal/pagamento/express-checkout/autorizacao',
      headers: {
        'Authorization' : window.localStorage['ls.token'],
        'Accept' : 'application/json'
      }
    },
  });
}
